<h3>{{data.titrePopup}}</h3>


<div class="row" style="margin-bottom: 5%;">
    <div class="large-12 columns" > {{data.texte}} <span  *ngIf="data.code">{{data.code}}</span>
  </div>
</div>
<div class="row" style="margin-bottom: 5%; margin-left: 5%;">
  <mat-select *ngIf="data.languesFacture"
             [(ngModel)]="dataLangue" placeholder="{{ 'POPUP.TEXT.INVOICE.MESSAGE' | translate }}*">
    <mat-option *ngFor="let langue of data.languesFacture" [value]="langue">{{langue.label}}</mat-option>
  </mat-select>
</div>

<div class="row">
  <button mat-raised-button color="primary" (click)="onClosedConfirm()"><span style="color:white">{{data.bottunOk}}</span></button>
  <button mat-button (click)="onClosedCancel()">{{data.bottunKo}}</button>
</div>


